function updatePriceinBtn(){
  
  const priceBtn = document.querySelector(".nwrapperPriceBtn");
  const quantity__input = document.querySelector('.product__info-container .quantity__input');
  const paywhirlselected = document.querySelector('.juo-selector [name="mode"]:checked');

  const wrapperOneTimePrice = document.querySelector('.juo-selector__option--otp .juo-summary__price');

  let currentVariant = getCurrentVariant();
  
  let q = 1;
  let priceselect=0;
  if(Boolean(currentVariant)){
    priceselect= parseInt(currentVariant.price)/100;
    let convertprice = priceselect.toString().replace('.', ',');
    if(Boolean(wrapperOneTimePrice)) wrapperOneTimePrice.innerHTML = `€${convertprice}`;
  }

  if(Boolean(quantity__input)){
    q = parseInt(quantity__input.value);
  }

  let priceInButton = priceselect;

  if(Boolean(paywhirlselected)){
    if(Boolean(currentVariant)){
      const sellingplanselectedID = document.querySelector('.juo-delivery .juo-delivery__option[data-active]');
      let sellingplan = currentVariant.selling_plan_allocations.find(data => { return data.selling_plan_id.toString() == sellingplanselectedID.dataset.value });

      if(paywhirlselected.value=="subscription"){
        priceInButton = parseInt(sellingplan.price)/100;
      }
    }
  }
  
  let pricewithq =  priceInButton * q;
  let numStr = pricewithq.toFixed(2).toString(); // convert to string
  let newNumStr = numStr.replace('.', ',');
  
  priceBtn.innerHTML=`• ${newNumStr} €`;
}

function getCurrentVariant(){
  console.log('jjjjjproductData');
  window.productjson = document.querySelector('#infoProductJSON[type="application/json"]');
  let productData = JSON.parse(window.productjson.textContent);
  console.log(productData);
  const currentVariantId = document.querySelector(".product-form [name=id]").value;
console.log(currentVariantId);
  if(Boolean(window.variantjson)){
    let variantData = JSON.parse(window.variantjson.textContent);
    getcurrentvariant = variantData.find(data => { return data.id.toString() == currentVariantId });
    return getcurrentvariant;
  }else{
    getcurrentvariant = productData.variants.find(data => { return data.id.toString() == currentVariantId });
    return getcurrentvariant;
  }
  return false;
}
document.addEventListener("DOMContentLoaded", () => {

  const optsSuscriptions = document.querySelectorAll('.juo-selector [name="mode"]');
  optsSuscriptions.forEach(inputr=>{
    inputr.addEventListener("change",(event)=>{
      console.log(inputr);
      if(inputr.value == "subscription"){
        console.log("subscription");
        document.querySelectorAll('variant-radios .saving.suscription').forEach(sav=>sav.classList.remove("hidden"));
        document.querySelectorAll('variant-radios .saving.onetime').forEach(sav=>sav.classList.add("hidden"));
      }else{
        console.log("else");
        document.querySelectorAll('variant-radios .saving.suscription').forEach(sav=>{
          console.log(sav);
          sav.classList.add("hidden");
        });
        document.querySelectorAll('variant-radios .saving.onetime').forEach(sav=>sav.classList.remove("hidden"));
      }
      console.log(inputr);
      updatePriceinBtn();
    });
  });
  
  const quantity__input = document.querySelector('.product__info-container .quantity__input');
  if(Boolean(quantity__input)){
    quantity__input.addEventListener("input",e=>{
      updatePriceinBtn();
    });
    quantity__input.addEventListener("change",e=>{
      updatePriceinBtn();
    });
  }

  /*let variantSelector = document.querySelector('.product__info-wrapper [name=id]');
  variantSelector.addEventListener('change', function() {
    let selectedVariantId = variantSelector.value;
    let variantData = JSON.parse(variantjson.textContent);
    let getcurrentvariant = variantData.find(data => { return data.id.toString() == selectedVariantId });
    let htmlprice = getcurrentvariant.price/100;
  });*/
  
  const btnsOpenVideo = document.querySelectorAll('.nuestros-clientes-carousel modal-opener .product-popup-modal__button');
  btnsOpenVideo.forEach(btn=>{
    btn.addEventListener("click",e=>{
      let typevideo = btn.dataset.typevideo;
      let dataid = btn.dataset.mediaId;
      let modalid = btn.dataset.modalid;
      if(typevideo=="youtube"){
        let url = `https://www.youtube.com/embed/${dataid}?enablejsapi=1`
        let iFrameObj = document.createElement('iframe');
        iFrameObj.classList.add("js-youtube");
        iFrameObj.src = url;
        let modalOpenVideo = document.querySelector(`#${modalid} deferred-media`);
        let modalOpenVideoIfram = document.querySelector(`#${modalid} deferred-media iframe`);
        if(Boolean(modalOpenVideoIfram)){
          //
        }else{
          modalOpenVideo.appendChild(iFrameObj);
          iFrameObj.addEventListener("load", l=>{
            modalOpenVideo.setAttribute("loaded", true);
          });  
        }
        
      }
      console.log(btn);
    });
  });
  
  const inputVariant = document.querySelector('.product-form .form input[name="id"]');
  const variantjson = document.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
  window.variantjson = document.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
  updatePriceinBtn();
  
  let onetimeLabel = document.querySelector("#paywhirl-one-time-purchase-group .paywhirl-label");
  let boxPrice = document.createElement("div");
  boxPrice.classList.add("boxPrice", "paywhirl-price");
  
  if(Boolean(variantjson)){
    let variantData = JSON.parse(variantjson.textContent);
    let getcurrentvariant = variantData.find(data => { return data.id.toString() == inputVariant.value });
    let htmlprice = getcurrentvariant.price/100;
    boxPrice.setAttribute("data-pricenum", htmlprice);
    let numStr = htmlprice.toString(); // convert to string
    let newNumStr = numStr.replace('.', ','); 
    //boxPrice.innerHTML= `${htmlprice.replace(".", ",")} €`;
    boxPrice.innerHTML = `${newNumStr} €`;

    
    if(Boolean(onetimeLabel)){
      onetimeLabel.append(boxPrice);
    }
  }else{
    let priceBtn = document.querySelector(".nwrapperPriceBtn");
    if(Boolean(priceBtn)){
      boxPrice.setAttribute("data-pricenum", `${priceBtn.dataset.firstprice.replace(",",".")}`);
      boxPrice.innerHTML= `${priceBtn.dataset.firstprice.replace(".", ",")} €`;
      if(Boolean(onetimeLabel)){
        onetimeLabel.append(boxPrice);
      }
    }
    
  }

  if(Boolean(inputVariant)){
    inputVariant.addEventListener("change", e => {
      document.querySelectorAll("video").forEach(video=>video.play());
      
      if(Boolean(variantjson)){
        /*
        let variantData = JSON.parse(variantjson.textContent);
        getcurrentvariant = variantData.find(data => { return data.id.toString() == e.target.value });
        if(getcurrentvariant){
          if(getcurrentvariant.selling_plan_allocations.length==0){
            let htmlpricenoselling = getcurrentvariant.price/100;
            let priceBtnsell = document.querySelector(".nwrapperPriceBtn");
            priceBtnsell.setAttribute("data-firstprice", htmlpricenoselling);
            updatePriceinBtn();
          }
        }
        */
      }
      
      updatePriceinBtn();
      if(window.intensidad){
      let getvariant = window.intensidad.filter(data => { return data.id.toString() == e.target.value });

      if(getvariant.length>0){
        let fraganceWrapperCont = document.querySelector('.fraganceWrapper');
        let fraganceWrapper = document.querySelectorAll('.fraganceWrapper .intensityItem');
        
        //fraganceWrapperCont.classList.remove("lavanda", "floral", "no", "default");
        //fraganceWrapperCont.classList.add(getvariant[0].color);

        fraganceWrapper.forEach(item=>{
          item.classList.remove("checkint");
          item.setAttribute('style', `--intense:${getvariant[0].color};`);
        });
        
        fraganceWrapper.forEach((item, index)=>{
          if((index+1)<=getvariant[0].intensidad){
            item.classList.add("checkint");
          }
    
          //item.classList.remove("checkint");
        });
      }
      }
      
    });
  }

  let btnsloadmore = document.querySelectorAll(".loadmore_btn-wrapper");
  if(Boolean(btnsloadmore)){
    btnsloadmore.forEach(btn=>{
      btn.addEventListener("click",e=>{
        e.preventDefault();
    
        Array.from(btn.previousSibling.children).forEach(item=>{
          item.classList.remove("hidden");
        });
        btn.classList.add("hidden");

      });
    })
  }
  
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById('cart-icon-bubble');
  const config = { attributes: true, childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    mutationsList.forEach(mutation=>{
      let lastcont = mutation.target.lastChild;
      if(Boolean(lastcont)){
        if(lastcont.classList.contains("cart-count-bubble")){
          let nroitems = lastcont.querySelector("[aria-hidden=true]").innerText;
          document.querySelector(".drawer__heading span").innerText= `(${nroitems})`;
        }
      }
    })
  };

});



